import { useEffect, useState } from "react";

import { useGetEdiSplitsQuery } from "../../../store/queries/ediConversion";
import { IEdiSplitBatch } from "../../../types/ediConversionFile";
import { EDI_POLL_INTERVAL_MS, isSplitBatchInFlight } from "./ediFileStatus";

const NO_BATCHES: IEdiSplitBatch[] = [];

/**
 * CLE-2921 — the split batches, polled every 5 s while any batch is splitting or any piece is
 * processing, and not at all once everything has settled (held pieces included: nothing happens to
 * them until someone processes them).
 *
 * Used by both the EDI Files container (so a split that finishes while another sub-tab is open still
 * refreshes the files list) and the "Split 835 Files" tab. They share one RTK Query cache entry, so
 * this is one request per cycle, not two.
 */
export function useEdiSplits() {
  const [polling, setPolling] = useState(false);
  const { data, isLoading, isError } = useGetEdiSplitsQuery(undefined, {
    pollingInterval: polling ? EDI_POLL_INTERVAL_MS : 0,
    refetchOnMountOrArgChange: true,
  });
  const batches = data?.data ?? NO_BATCHES;
  const inFlight = batches.some(isSplitBatchInFlight);

  // The polling decision is read from the data the query returned, so it can only follow it.
  useEffect(() => {
    setPolling(inFlight);
  }, [inFlight]);

  return { batches, isLoading, isError, isLoaded: !!data };
}
